import { Link } from "react-router-dom";
import { Plane, Map, RouteIcon } from "./ServiceIcons";
import { ArrowRight } from "lucide-react";

const SERVICES = [
  {
    to: "/servicios/aeropuerto-y-tours",
    icon: Plane,
    kicker: "Servicio 01",
    title: "Aeropuerto y Tours",
    desc: "Traslados puntuales al aeropuerto El Dorado y tours turísticos dentro y fuera de Bogotá.",
    bullets: ["Puntualidad garantizada", "Van, buseta o bus", "Alquiler por horas / día"],
    bg: "/servicio-001.webp",
  },
  {
    to: "/servicios/transporte-turistico-colombia",
    icon: Map,
    kicker: "Servicio 02",
    title: "Transporte por toda Colombia",
    desc: "Rutas turísticas e intermunicipales desde Bogotá hacia cualquier destino del país.",
    bullets: ["Cobertura 32 departamentos", "Grupos desde 5 pax", "Conductores certificados"],
    bg: "/servicio-002.webp",
  },
  {
    to: "/servicios/rutas",
    icon: RouteIcon,
    kicker: "Servicio 03",
    title: "Rutas Empresariales, Escolares y Nocturnas",
    desc: "Rutas fijas para empresas, colegios y turnos nocturnos en Bogotá.",
    bullets: ["Turnos rotativos", "Seguridad escolar", "Puntualidad diaria"],
    bg: "/servicio-003.webp",
  },
];

export default function ServiceCards() {
  return (
    <section id="servicios" data-testid="service-cards-section" className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">Nuestros servicios</div>
          <h2 className="font-display text-4xl md:text-5xl leading-tight text-[#F5EFE0]">
            Tres formas de <span className="italic text-gold-grad">moverte</span> con Líneas Doradas
          </h2>
          <p className="text-[#F5EFE0]/65 mt-4 text-base md:text-lg">
            Elige la línea de servicio que necesitas — cada una opera con vehículos verificados y conductores certificados.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.to}
                to={s.to}
                data-testid={`service-card-${i}`}
                className="card-lux p-7 group flex flex-col relative overflow-hidden isolate min-h-[440px]"
              >
                {/* faded background image */}
                <img
                  src={s.bg}
                  alt=""
                  aria-hidden="true"
                  className="absolute inset-0 w-full h-full object-cover opacity-25 group-hover:opacity-35 -z-10"
                  style={{ transitionProperty: "opacity", transitionDuration: "400ms" }}
                />
                {/* dark bottom-fade overlay for text legibility */}
                <div
                  aria-hidden="true"
                  className="absolute inset-0 -z-10 pointer-events-none"
                  style={{ background: "linear-gradient(180deg, rgba(10,9,8,0.55) 0%, rgba(10,9,8,0.85) 55%, rgba(10,9,8,0.95) 100%)" }}
                />

                <div className="text-[10px] uppercase tracking-[0.35em] text-[#D4AF37] mb-4">{s.kicker}</div>
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/12 border border-[#D4AF37]/35 flex items-center justify-center mb-5 group-hover:bg-[#D4AF37]/20 backdrop-blur-sm"
                     style={{ transitionProperty: "background-color", transitionDuration: "250ms" }}>
                  <Icon size={22} className="text-[#E8C87A]" />
                </div>
                <h3 className="font-display text-2xl text-[#F5EFE0] mb-3">{s.title}</h3>
                <p className="text-sm text-[#F5EFE0]/70 leading-relaxed mb-5 flex-1">{s.desc}</p>
                <ul className="space-y-1.5 mb-6">
                  {s.bullets.map((b) => (
                    <li key={b} className="text-xs text-[#F5EFE0]/80 flex items-center gap-2">
                      <span className="w-1 h-1 rounded-full bg-[#D4AF37]" /> {b}
                    </li>
                  ))}
                </ul>
                <div className="flex items-center gap-2 text-sm text-[#E8C87A] group-hover:gap-3"
                     style={{ transitionProperty: "gap", transitionDuration: "220ms" }}>
                  Ver más <ArrowRight size={14} />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
